export const isNumber = (value: any): boolean => {
  return Number(value) === value;
};
